// extracted by mini-css-extract-plugin
module.exports = {"bb-button":"bb-button__tjPjF","bb-button__center":"bb-button__center__MuLp1"};